import { cn } from "@edusogno/lib/utils";
import { AnimatePresence } from "framer-motion";

type Props = {
  className?: string;
  children?: React.ReactNode;
};
const Card: React.FC<Props> = ({ className, children }) => {
  return (
    <div
      className={cn(
        "flex flex-col w-[300px] h-full bg-white rounded-md",
        className,
      )}
    >
      <AnimatePresence>{children}</AnimatePresence>
    </div>
  );
};
export default Card;
